var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDefaultUserPicture = function SvgDefaultUserPicture(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6812 42.25H39.3188V40.25H26.6812V42.25ZM39.3188 42.25C44.3894 42.25 48.5 46.3606 48.5 51.4312H50.5C50.5 45.256 45.494 40.25 39.3188 40.25V42.25ZM26.6812 40.25C20.506 40.25 15.5 45.256 15.5 51.4312H17.5C17.5 46.3606 21.6106 42.25 26.6812 42.25V40.25ZM40.25 24.75C40.25 28.7541 37.0041 32 33 32V34C38.1086 34 42.25 29.8586 42.25 24.75H40.25ZM33 32C28.9959 32 25.75 28.7541 25.75 24.75H23.75C23.75 29.8586 27.8914 34 33 34V32ZM25.75 24.75C25.75 20.7459 28.9959 17.5 33 17.5V15.5C27.8914 15.5 23.75 19.6414 23.75 24.75H25.75ZM33 17.5C37.0041 17.5 40.25 20.7459 40.25 24.75H42.25C42.25 19.6414 38.1086 15.5 33 15.5V17.5ZM56.75 33C56.75 46.1168 46.1168 56.75 33 56.75V58.75C47.2213 58.75 58.75 47.2213 58.75 33H56.75ZM33 56.75C19.8832 56.75 9.25 46.1168 9.25 33H7.25C7.25 47.2213 18.7787 58.75 33 58.75V56.75ZM9.25 33C9.25 19.8832 19.8832 9.25 33 9.25V7.25C18.7787 7.25 7.25 18.7787 7.25 33H9.25ZM33 9.25C46.1168 9.25 56.75 19.8832 56.75 33H58.75C58.75 18.7787 47.2213 7.25 33 7.25V9.25Z",
    fill: "#151A22",
    fillOpacity: 0.4
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDefaultUserPicture, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/default-user-picture.a8790bbd.svg";
export { ForwardRef as ReactComponent };